// Actions
import { createRequestTypes } from "../../utils";

export const FETCH_PRICES = createRequestTypes("FETCH_PRICES");

// Action creators
export const fetchPricesRequest = () =>
  ({ type: FETCH_PRICES.REQUEST });

export const fetchPricesSuccess = (prices) =>
  ({ type: FETCH_PRICES.SUCCESS, payload: { prices } });

export const fetchPricesFailure = (error) =>
  ({ type: FETCH_PRICES.FAILURE, payload: { error } });
